import { Tag } from 'antd';

interface Props {
  value: string | null | undefined;
  map: Record<string, { label: string; color: string }>;
}

export function StatusBadgeCellRenderer({ value, map }: Props) {
  if (value == null || value === '') return <span style={{ color: 'var(--color-text-muted)' }}>—</span>;
  const entry = map[value];
  if (!entry) return <span>{value}</span>;
  return <Tag color={entry.color}>{entry.label}</Tag>;
}
